module.exports = __webpack_public_path__ + "media/ydl.f9f06b43.mp3";